import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
// import { TimePicker } from 'antd'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { useLocalization } from '@contexts/LocalizationContext'
// import { Input } from 'antd'
import { Row, Col, Button, DatePicker, Form, Input } from 'antd'
import { validationSchema } from './validationSchema'
// import { client } from '@utils/client'
dayjs.extend(customParseFormat)
const FormComponent = ({ handleSubmit, defaultValues = {}, doStatus }) => {
  const { t } = useLocalization()
  const { RangePicker } = DatePicker

  const [form] = Form.useForm()

  const style = {
    inputForm: { width: '95%', height: '40px', marginRight: '10px' },
    inputDynamicField: {
      width: '100%',
      height: '40px',
    },
    inputDateForm: { width: '95%', height: '40px' },
    btnStyleSummitAdd: {
      height: '37px',
      width: '232px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
    btnStyleSummit: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
    btnStyleCancel: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
      color: '#56B9C3',
    },
  }
  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  useEffect(() => {
    form.resetFields()
  }, [defaultValues])

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().endOf('day').add(-1, 'day')
  }

  const yupSync = {
    async validator({ field }, value) {
      try {
        await validationSchema(t).validateSyncAt(field, { [field]: value })
      } catch (error) {
        console.log(error)
        throw error
      }
    },
  }

  return (
    <Form
      layout="vertical"
      form={form}
      name="control-hooks"
      onFinish={handleSubmit}
      initialValues={defaultValues}
      requiredMark={false}
    >
      {/* "DD-MM-YYYY" */}
      <Row>
        <Col flex="auto">
          <div hidden>
            <Form.Item name="id">
              {/* ฝาก Id ไปกับ Form เนื่องจากเป็น modal ฝากไปกับ path ไม่ได้ */}
              <Input />
            </Form.Item>
          </div>
          <Row style={{ width: '100%', padding: '0px 0px 8px' }}>
            <Col span={12}>{t('rewards.specialEvent.form.start')}</Col>
            <Col span={12}>{t('rewards.specialEvent.form.end')}</Col>
          </Row>
          <Form.Item
            name="startToEnd"
            rules={[
              {
                required: true,
                message: t('rewards.specialEvent.error.startToEnd'),
              },
            ]}
          >
            <RangePicker
              disabledDate={disabledDate}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [
                  dayjs('00:00:00', 'HH:mm:ss'),
                  dayjs('11:59:59', 'HH:mm:ss'),
                ],
              }}
              format="YYYY-MM-DD HH:mm"
              style={style.inputForm}
            />
          </Form.Item>
          <Form.Item
            name="name"
            label={t('rewards.specialEvent.form.name')}
            rules={[
              {
                required: true,
                message: t('rewards.specialEvent.error.name'),
              },
            ]}
          >
            <Input style={style.inputForm} />
          </Form.Item>
          <Form.Item
            name="point"
            label={t('rewards.specialEvent.form.point')}
            rules={[yupSync]}
          >
            <Input style={style.inputForm} />
          </Form.Item>

          {/* เเสดงปุ่ม */}
          <Form.Item {...tailLayout}>
            <div style={{ textAlign: 'center' }}>
              {doStatus === 'create' ? (
                <Button
                  type="primary"
                  htmlType="submit"
                  style={style.btnStyleSummitAdd}
                >
                  {t('rewards.shop.form.addData')}
                </Button>
              ) : (
                <div
                  style={{ display: 'flex', justifyContent: 'space-evenly' }}
                >
                  <Button htmlType="button" style={style.btnStyleCancel}>
                    {t('rewards.shop.form.cancel')}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={style.btnStyleSummit}
                  >
                    {t('rewards.shop.form.confirm')}
                  </Button>
                </div>
              )}
            </div>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
}

export default FormComponent
